var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.regionteam.region_team_invites.length)?_c('div',{staticClass:"admin-comment"},[_c('div',{staticClass:"separator"}),_c('h3',[_vm._v("Сотрудники компании")]),_c('region-team-member-list-item')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }